export const products = {
  allInOneWirelessPrinter: {
    title: "All-in-One Wireless Printer",
    brand: "HP",
    images: [
      "/assets/img/p2.jpg",
      "/assets/img/p3.jpg",
      "/assets/img/p4.jpg",
      "/assets/img/p5.jpg",
    ],
    rating: "★★★★☆",
    reviewCount: 120,
    price: 400,
    originalPrice: 580,
    savingsLabel: "Save 31%",
    quantities: [1, 2, 3, 4],
    features: [
      { icon: "fas fa-wifi", color: "text-primary", text: "Wireless printing from multiple devices" },
      { icon: "fas fa-bolt", color: "text-warning", text: "High-speed laser print technology" },
      { icon: "fas fa-tint", color: "text-danger", text: "Includes Ink & Toner Cartridges" },
      { icon: "fas fa-shield-alt", color: "text-success", text: "1-Year Warranty Included" },
    ],
    description:
      "This all-in-one wireless printer is designed for home and office use. It offers high-speed printing with laser technology, delivering sharp and vibrant results. Print from multiple devices seamlessly using wireless connectivity.",
    reviews: [
      {
        name: "John Doe",
        rating: "★★★★★",
        quote: "Setup was seamless and print quality is top-notch. Highly recommend for home offices!",
      },
      {
        name: "Jane Smith",
        rating: "★★★★☆",
        quote: "Great value for the price, but the toner runs out faster than expected.",
      },
    ],
  },
  highSpeedLaserPrinter: {
    title: "High-Speed Laser Printer",
    brand: "Brother",
    images: ["/assets/img/p3.jpg"],
    rating: "★★★★☆",
    reviewCount: 145,
    price: 300,
    quantities: [1, 2, 3, 4, 5],
    features: [
      { icon: "fas fa-bolt", color: "text-warning", text: "Ultra-Fast Laser Printing" },
      { icon: "fas fa-network-wired", color: "text-primary", text: "Network and Wireless Connectivity" },
      { icon: "fas fa-file-alt", color: "text-success", text: "Double-Sided Printing (Duplex)" },
      { icon: "fas fa-shield-alt", color: "text-danger", text: "Secure Print Feature" },
    ],
    description:
      "The High-Speed Laser Printer offers exceptional print quality and efficiency, making it ideal for office and home use. With fast print speeds and wireless connectivity, you can print large volumes without interruption.",
    reviews: [
      {
        name: "Michael Roberts",
        rating: "★★★★★",
        quote: "Best laser printer I've used. It is fast and prints clear, sharp documents.",
      },
      {
        name: "Anna Clark",
        rating: "★★★★☆",
        quote: "Reliable and efficient. The double-sided printing is a game changer.",
      },
    ],
  },
  genuineInkToner: {
    title: "Genuine Ink & Toner Cartridges",
    brand: "Canon",
    images: ["/assets/img/p4.jpg"],
    rating: "★★★★★",
    reviewCount: 85,
    price: 60,
    quantities: [1, 2, 3, 4, 5],
    features: [
      { icon: "fas fa-tint", color: "text-danger", text: "High-Quality Genuine Ink" },
      { icon: "fas fa-check-circle", color: "text-primary", text: "Compatible with Major Printer Brands" },
      { icon: "fas fa-shield-alt", color: "text-success", text: "Smudge-Free and Long-Lasting" },
      { icon: "fas fa-recycle", color: "text-warning", text: "Eco-Friendly and Recyclable" },
    ],
    description:
      "Our genuine ink and toner cartridges are designed to deliver sharp, vibrant prints every time. They are compatible with major printer brands and built for reliable, long-lasting performance.",
    reviews: [
      {
        name: "Sarah Thompson",
        rating: "★★★★★",
        quote: "The ink quality is fantastic and lasts a long time. Perfect for office printing needs.",
      },
      {
        name: "James Carter",
        rating: "★★★★☆",
        quote: "Great ink, but I wish the toner capacity was a little higher. Otherwise, excellent product.",
      },
    ],
  },
  a4PrinterPaper: {
    title: "Premium A4 Printer Paper",
    brand: "PaperCo",
    images: ["/assets/img/p5.jpg"],
    rating: "★★★★★",
    reviewCount: 200,
    price: 20,
    quantities: [1, 2, 3, 4, 5],
    features: [
      { icon: "fas fa-file-alt", color: "text-primary", text: "High-Quality A4 Paper" },
      { icon: "fas fa-recycle", color: "text-success", text: "Eco-Friendly and Recyclable" },
      { icon: "fas fa-print", color: "text-danger", text: "Compatible with All Printers" },
      { icon: "fas fa-box", color: "text-warning", text: "500 Sheets per Pack" },
    ],
    description:
      "This Premium A4 Printer Paper is designed for high-quality printing. It is suitable for professional documents, reports, and presentations, with smooth, jam-free performance in inkjet and laser printers.",
    reviews: [
      {
        name: "Linda Cooper",
        rating: "★★★★★",
        quote: "The best paper I've used for my printer. The quality is superb, and it is eco-friendly too.",
      },
      {
        name: "James Wright",
        rating: "★★★★☆",
        quote: "Very smooth and high quality. The price is affordable, and the delivery was quick.",
      },
    ],
  },
  photoPrinter: {
    title: "Portable Photo Printer",
    brand: "PrintEase",
    images: ["/assets/img/p6.jpg"],
    rating: "★★★★☆",
    reviewCount: 95,
    price: 150,
    quantities: [1, 2, 3, 4, 5],
    features: [
      { icon: "fas fa-camera", color: "text-primary", text: "Instant Photo Printing" },
      { icon: "fas fa-wifi", color: "text-success", text: "Wireless Connectivity" },
      { icon: "fas fa-tint", color: "text-danger", text: "High-Resolution Printing" },
      { icon: "fas fa-battery-full", color: "text-warning", text: "Long Battery Life" },
    ],
    description:
      "Capture your memories instantly with the Portable Photo Printer by PrintEase. It is built for events, travel, and everyday use, with wireless high-resolution printing from your phone or camera.",
    reviews: [
      {
        name: "Samantha Lee",
        rating: "★★★★★",
        quote: "Absolutely love this portable printer. Great print quality and easy to use.",
      },
      {
        name: "Michael Brown",
        rating: "★★★★☆",
        quote: "Compact and works well. Prints are high quality, but I wish it came with extra cartridges.",
      },
    ],
  },
  colorLaserJet: {
    title: "Color LaserJet Printer",
    brand: "Canon",
    images: ["/assets/img/p5.jpg"],
    rating: "★★★★☆",
    reviewCount: 110,
    price: 550,
    originalPrice: 700,
    savingsLabel: "Save 21%",
    quantities: [1, 2, 3, 4, 5],
    features: [
      { icon: "fas fa-print", color: "text-primary", text: "High-Speed Color Printing" },
      { icon: "fas fa-wifi", color: "text-success", text: "Wireless Connectivity" },
      { icon: "fas fa-tint", color: "text-danger", text: "Efficient Toner Usage" },
      { icon: "fas fa-cogs", color: "text-warning", text: "Auto-Duplex Printing" },
    ],
    description:
      "The Color LaserJet Printer by Canon is designed for home and office use. Experience high-speed, vibrant color prints with efficient toner usage and wireless connectivity.",
    reviews: [
      {
        name: "Alice Parker",
        rating: "★★★★★",
        quote: "The best color printer I have used. Easy to set up and prints are vibrant and professional-looking.",
      },
      {
        name: "James Miller",
        rating: "★★★★☆",
        quote: "Great quality prints, but a bit noisy during operation. Overall, a great buy.",
      },
    ],
  },
};
